import React from "react";

import useAdminSidebar from "./adminShell/hooks/useAdminSidebar";
import DesktopSidebar from "./adminShell/components/DesktopSidebar";
import MobileSidebar from "./adminShell/components/MobileSidebar";

export default function AsideMenu() {
  const {
    isCollapsed,
    shellWidth,
    mobileOpen,
    visibleSections,
    permissionsLoaded,
    pathname,
    openMobile,
    closeMobile,
    toggleCollapsed,
  } = useAdminSidebar();

  if (!permissionsLoaded) return null;
  if (!visibleSections.length) return null;

  return (
    <>
      <MobileSidebar
        mobileOpen={mobileOpen}
        pathname={pathname}
        visibleSections={visibleSections}
        onOpen={openMobile}
        onClose={closeMobile}
      />

      <DesktopSidebar
        shellWidth={shellWidth}
        isCollapsed={isCollapsed}
        pathname={pathname}
        visibleSections={visibleSections}
        onToggleCollapsed={toggleCollapsed}
      />
    </>
  );
}